__turbopack_context__.v({
  "button": "StickyBar-module__uHkIYW__button",
  "buttonContainer": "StickyBar-module__uHkIYW__buttonContainer",
  "container": "StickyBar-module__uHkIYW__container",
  "fade-in": "StickyBar-module__uHkIYW__fade-in",
  "fade-out": "StickyBar-module__uHkIYW__fade-out",
  "heading": "StickyBar-module__uHkIYW__heading",
  "hide": "StickyBar-module__uHkIYW__hide",
  "innerContainer": "StickyBar-module__uHkIYW__innerContainer",
  "show": "StickyBar-module__uHkIYW__show",
  "topBar": "StickyBar-module__uHkIYW__topBar",
});
